import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  FormHelperText,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createApiUser,
  getAllAppConfig,
  getAllRoles,
  getAllUser,
  getApiKey,
  getApiUserRoles,
  getSystemProvider,
  getUserByUserName,
  updateApiUser,
} from "../../Utils/actions";
import "./VUser.scss";
import cogoToast from "cogo-toast";
import AddRoles from "./AddRoles";
import { Card, Modal } from "react-bootstrap";
import { AppBar, Autocomplete, Tab, Tabs } from "@mui/material";
import VUserRole from "./VUserRole";
import { buttonStyle, tabStyle, tabsStyle } from "../../Style/ManualStyle";
import { validationMatch, validationMob } from "./validationCheck";
import DOMPurify from "dompurify";
import ShowAllUser from "./ShowAllUser";
import SaveIcon from "@mui/icons-material/Save";
import { makeStyles } from "@material-ui/core/styles";
import background from "../../Assets/Images/bgLicense.jpg";
import "../../App.css";
import { useLocation } from "react-router-dom";
import AppConfig from "../License/AppConfig";
import AppConfigPage from "../License/AppConfig/AppConfigPage";
import AddValidRole from "./ValidateFormTime/AddValidRole";
import AddRolePerm from "./ValidateFormTime/AddRolePerm";
import { errorMsg } from "../../Utils/errorMsg/ErrorMsg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Audit from "./Audit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import SecurityIcon from "@mui/icons-material/Security";

const VUser = () => {
  const { rolesData, userApiKey, userData, dataProvider } = useSelector(
    (state) => state.data
  );
  const [editing, setEditing] = useState(false);
  const [isUserEditOrAdd, setIsUserEditOrAdd] = useState(false);
  const [form, setForm] = useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    disp_name: "",
    company: "",
    apikey: "",
    fname: "",
    sname: "",
    active_status: "Y",
    dataProvider: "",
  });
  const [permission, setPermission] = useState(false);
  const [error, setError] = useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    disp_name: "",
    company: "",
    apikey: "",
    fname: "",
    sname: "",
    personName: "",
    dataProvider: "",
  });

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const dispatch = useDispatch();
  const location = useLocation();

  const { isUserValid } = useSelector((state) => state.auth);
  const [personName, setPersonName] = useState([]);
  const [dataProviderList, setDataProviderList] = useState([]);
  const [tabsVal, setTabsVal] = useState(
    !isUserValid
      ? { name: "roles", val: 0 }
      : location.pathname === "/validForm" || cmpntGroup["user"]?.Read
      ? { name: "user", val: 0 }
      : { name: "appProperties", val: 0 }
  );
  const [errorFocus, setErrorFocus] = useState("");
  const [isEditing, setIsEdting] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const [userTablePagination, setUserTablePagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [pageIndexAddUser, setPageIndexAddUser] = useState(0);
  const [pageSizeAddUser, setPageSizeAddUser] = useState(
    sessionStorage.getItem("addUserPageSize")
      ? sessionStorage.getItem("addUserPageSize")
      : 10
  );

  const [pageIndexAddRole, setPageIndexAddRole] = useState(0);
  const [pageSizeAddRole, setPageSizeAddRole] = useState(
    sessionStorage.getItem("addRolePageSize")
      ? sessionStorage.getItem("addRolePageSize")
      : 10
  );

  // const [roleTablePagination, setRoleTablePagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 10,
  // });

  // const [pageIndexRoleTable, setPageIndexRoleTable] = useState(0);
  // const [pageSizeRoleTable, setPageSizeRoleTable] = useState(10);

  const [pageIndexAppProp, setPageIndexAppProp] = useState(0);
  const [pageSizeAppProp, setPageSizeAppProp] = useState(
    sessionStorage.getItem("appPropPageSize")
      ? sessionStorage.getItem("appPropPageSize")
      : 10
  );

  // const [appConfigPagination, setAppConfigPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 10,
  // });

  const tabsNew = {
    ...tabsStyle,
    boxShadow: "none",
    position: "relative",
    // backgroundColor: "red !important",
    display: "flex",
    flexGrow: 1,
    padding: "0px",
    margin: "0px",
    padding: "0px",
    margin: "0px",
  };

  useEffect(() => {
    // dispatch(getApiKey());
    // if (isUserValid) {
    dispatch(getAllUser(pageSizeAddUser, pageIndexAddUser));
    // }
  }, [pageSizeAddUser, pageIndexAddUser]);

  useEffect(() => {
    dispatch(getAllRoles(pageSizeAddRole, pageIndexAddRole));
  }, [pageSizeAddRole, pageIndexAddRole]);

  const [rowData, setRowData] = useState({});
  const [userPermission, setUserPermission] = useState(false);
  useEffect(() => {
    setErrorFocus(errorFocus);
  }, [errorFocus]);

  useEffect(() => {
    setForm({ ...form, apikey: userApiKey });
  }, [userApiKey]);

  useEffect(() => {
    dispatch(getAllRoles(pageSizeAddRole, pageIndexAddRole));
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
    dispatch(getSystemProvider());
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    // Clear error message when user starts typing
    if (error[name]) {
      setError({ ...error, [name]: "" });
    }
    if (e.target.name === "personName") {
      setError({ ...error, [e.target.name]: "" });
      setPersonName(
        typeof value === "string" ? e.target.value.split(",") : e.target.value
      );
      return;
    }

    if (e.target.name === "dataProvider") {
      setError({ ...error, [e.target.name]: "" });
      setDataProviderList(
        typeof value === "string" ? e.target.value.split(",") : e.target.value
      );
      return;
    }

    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value.toString() });
    try {
      if (e.target.name === "username") {
        validationMatch(form.username, "username")
          ? setError({ ...error, username: "" })
          : setError({ ...error, username: "Validation process pending." });
        setErrorFocus(
          `<p className=${
            validationMatch(form.username, "username")
              ? "greenColor"
              : "redColor"
          }>1 . There has no space </p> `
        );
      }
      if (e.target.name === "email") {
        validationMatch(form.email, "email")
          ? setError({ ...error, email: "" })
          : setError({ ...error, email: "Validation process pending." });
        setErrorFocus(`<p>
                          <span className=${
                            validationMatch(form.email, "email")
                              ? "greenColor"
                              : "redColor"
                          }>1 . There has no special character like (a-z @) </span>
                        </p>`);
      }
      if (e.target.name === "disp_name") {
        validationMatch(form.disp_name, "disp_name")
          ? setError({ ...error, disp_name: "" })
          : setError({ ...error, disp_name: "Validation process pending." });
        setErrorFocus(`<p>
                          <span className=${
                            validationMatch(form.disp_name, "disp_name")
                              ? "greenColor"
                              : "redColor"
                          }>1 . Valid Display</span>
                        </p>`);
      }
      if (e.target.name === "mobile") {
        // const sanitizedValue = e.target.value.replace(/\D/g, "");

        // const trimmedValue = sanitizedValue.slice(0, 10);
        const sanitizedValue = value.replace(/\D/g, "");
        const trimmedValue = sanitizedValue.slice(0, 15);
        setForm({ ...form, mobile: trimmedValue });

        // setForm({
        //   ...form,
        //   [e.target.name]: trimmedValue,
        // });

        validationMob(trimmedValue)
          ? setError({ ...error, mobile: "" })
          : setError({ ...error, mobile: "Validation process pending." });

        setErrorFocus(
          `<p><span className=${
            validationMob(trimmedValue) ? "greenColor" : "redColor"
          }>
        1. It should have 10 characters.
      </span></p>`
        );
      }
      if (e.target.name === "password") {
        validationMatch(form.password, "password")
          ? setError({ ...error, password: "" })
          : setError({ ...error, password: "Validation process pending." });
        setErrorFocus(`<p>
                          <span className=${
                            validationMatch(form.password, "password")
                              ? "greenColor"
                              : "redColor"
                          }>1 . Valid Display</span>
                        </p>`);
      }
    } catch (err) {
      setErrorFocus(err);
    }
  };

  useEffect(() => {
    setForm({ ...form, ...userData });
    setPersonName(userData.roleName);
    setDataProviderList(userData.dataProvider);
  }, [userData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!form.username) {
    //   setError({ ...error, username: "User Name is required" });
    //   return;
    // }

    // if (!form.disp_name) {
    //   setError({ ...error, disp_name: "Display Name is required" });
    //   return;
    // }
    // if (!form.apikey) {
    //   setError({ ...error, apikey: "Api Key name is required" });
    //   return;
    // }
    // if (!form.password) {
    //   setError({ ...error, password: "Password is required" });
    //   return;
    // }
    const newErrors = {};
    if (!form.username) {
      newErrors.username = "User Name is required";
    }
    // if (!form.disp_name) {
    //   newErrors.disp_name = "Display Name is required";
    // }
    if (!form.apikey) {
      newErrors.apikey = "Api Key name is required";
    }
    if (!form.password) {
      newErrors.password = "Password is required";
    }

    if (
      (!personName || personName.length === 0) &&
      (!isEditing || (isEditing && personName.length === 0))
    ) {
      newErrors.personName = "Role is required";
    }
    if (!form.dataProvider) {
      newErrors.dataProvider = "Data Provider is required";
    }
    // if (!PhoneInput.isPossibleNumber(form.mobile)) {
    //   setError({ ...error, mobile: 'Please enter a valid mobile number' });
    //   return;
    // }

    setError(newErrors);
    if (Object.keys(newErrors).length === 0) {
      // try {
      if (!isUserEditOrAdd) {
        form.roleName = personName.join(",");
        form.dataProvider = dataProviderList.join(",");
        dispatch(
          createApiUser(form, location, pageSizeAddUser, pageIndexAddUser)
        );
      } else {
        form.roleName = personName;
        form.dataProvider = dataProviderList;
        dispatch(updateApiUser(form, pageSizeAddUser, pageIndexAddUser));
      }
      modalHideChange();
      // } catch (error) {
      //   errorMsg(`User Not successfully ${error}`);
      // }
    }
  };

  const getStyles = (name, personName) => {
    return personName != null && personName.length > 0
      ? {
          fontWeight: personName.indexOf(name.roleName) === -1 ? "400" : "700",
        }
      : {};
  };

  // const MenuProps = {
  //   PaperProps: {
  //     style: {
  //       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
  //       width: 250,
  //     },
  //   },
  // };

  useEffect(() => {
    dispatch(getAllAppConfig(pageSizeAppProp, pageIndexAppProp));
  }, [pageSizeAppProp, pageIndexAppProp]);

  // const tabNameToValue = {
  //   roles: 0,
  //   userRolesPerm: 1,
  //   user: 2,
  //   appProperties: 3,
  // };

  const onTabChange1 = (e, nextValue) => {
    console.log("nextValue11", nextValue);
    const userTable = {
      pageNumber: userTablePagination.pageIndex + 1,
      pageSize: userTablePagination.pageSize,
    };
    // if (nextValue === 0) {
    if (e.target.name === "user") {
      dispatch(getAllUser(pageSizeAddUser, pageIndexAddUser));
    }
    // if (nextValue === 2) {
    if (e.target.name === "appProperties") {
      dispatch(getAllAppConfig(pageSizeAppProp, pageIndexAppProp));
    }

    // if (nextValue === 3) {
    // if (e.target.name === "user") {
    //   dispatch(getAllUser(userTable));
    // }
    setTabsVal({ ...tabsVal, name: e.target.name, val: nextValue });
  };

  const setTabs = (tabVal) => {
    setTabsVal(tabVal);
  };

  const handleChangesOnFocus = () => {
    setErrorFocus("");
  };

  const useStyles = makeStyles((theme) => ({
    input: {
      "&::placeholder": {
        color: "#000000", // Customize the color here
      },
      color: "#000000",
    },
  }));
  const onClickEdting = (row) => {
    setEditing(true);
    setIsUserEditOrAdd(true);
    setIsEdting(true);
    dispatch(getUserByUserName(row.original.username));
    setUserPermission(true);
  };

  const onCancelEditing = (isEditing) => {
    if (isEditing) {
      setIsUserEditOrAdd(false);
      setForm({
        username: "",
        email: "",
        mobile: "",
        password: "",
        disp_name: "",
        company: "",
        apikey: "",
        fname: "",
        sname: "",
        active_status: "Y",
      });
      setPersonName([]);
      setDataProviderList([]);
      setEditing(false);
      setIsEdting(!isEditing);
      setUserPermission(false);
    }
  };

  const modalHideChange = () => {
    setUserPermission(false);
    setError({
      username: "",
      email: "",
      mobile: "",
      password: "",
      disp_name: "",
      company: "",
      apikey: "",
      fname: "",
      sname: "",
      active_status: "Y",
    });
    setIsEdting(false);
  };

  const handleSetUser = (isCheck) => {
    dispatch(getApiKey());
    setIsUserEditOrAdd(false);
    setForm({
      username: "",
      email: "",
      mobile: "",
      password: "",
      disp_name: "",
      company: "",
      apikey: "",
      fname: "",
      sname: "",
      active_status: "Y",
    });
    setEditing(false);
    setPersonName([]);
    setDataProviderList([]);
    setUserPermission(isCheck);
  };
  // const dataProviderWithAll = [...dataProvider, { label: 'ALL', value: 'ALL' }];
  const textPlaceHolder = useStyles();
  return (
    <>
      <div
        style={{
          backgroundColor: "#333333",
          height: "89vh",
          padding: "15px",
          overflow: "hidden",
          border: "none",
        }}
        className="Admin"
      >
        <div
          className={"d-flex col-sm-12 white_paper before-login"}
          style={{
            backgroundColor: "#242424",
            overflow: "hidden",
            borderRadius: "5px",
            padding: "0px",
            height: "100%",
          }}
        >
          <div
            className={"col-sm-12 before-login-header "}
            style={{ marginTop: "25px" }}
          >
            <AppBar
              style={{
                boxShadow: "none",
                position: "relative",
                background: "none",
                padding: "0px",
                margin: "0px",
                backgroundColor: "#1e1e1e",
                color: "#c7c7c7",
                zIndex: "auto",
                paddingLeft: "15px",
              }}
            >
              {!isUserValid ? (
                <Tabs
                  value={tabsVal.val}
                  onChange={onTabChange1}
                  aria-label="profile tabs"
                  aria-setsize={"60px"}
                  style={tabsNew}
                >
                  <Tab
                    label="Add Roles Permission"
                    value={0}
                    name="roles"
                    // style={tabStyle}
                    sx={{
                      ...tabStyle,
                      backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                      fontWeight: tabsVal === 0 ? "bold" : "normal",
                    }}
                  />
                  {/* <Tab label="Add Roles Permission" value={1} name="userRolesPerm" style={tabStyle} /> */}
                  <Tab
                    label="Add User"
                    value={1}
                    name="user"
                    // style={tabStyle}
                    sx={{
                      ...tabStyle,
                      backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                      fontWeight: tabsVal === 0 ? "bold" : "normal",
                    }}
                  />
                  {/* <Tab label="Audit" value={3} name="audit" style={tabStyle} /> */}
                  {/* <Tab label="Show User" style={tabStyle} /> */}
                  {/* {sessionStorage.getItem("username").toLowerCase().match("admin") ? <Tab label="Show User" style={tabStyle} /> : null } */}
                </Tabs>
              ) : (
                <Tabs
                  value={tabsVal.val}
                  onChange={onTabChange1}
                  style={{ ...tabsStyle, backgroundColor: "#1e1e1e" }}
                >
                  {cmpntGroup["user"]?.Read ? (
                    <Tab
                      label="Add User"
                      value={0}
                      name="user"
                      // style={tabStyle}
                      sx={{
                        ...tabStyle,
                        backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                        fontWeight: tabsVal === 0 ? "bold" : "normal",
                      }}
                      className="AdminTab"
                    />
                  ) : null}
                  {cmpntGroup["user"]?.Read ? (
                    <Tab
                      label="Add Roles"
                      value={1}
                      name="userRoles"
                      // style={tabStyle}
                      sx={{
                        ...tabStyle,
                        backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                        fontWeight: tabsVal === 0 ? "bold" : "normal",
                      }}
                      className="AdminTab"
                    />
                  ) : null}
                  {cmpntGroup["appProperties"]?.Read ? (
                    <Tab
                      label="App Properties"
                      value={2}
                      name="appProperties"
                      // style={tabStyle}
                      sx={{
                        ...tabStyle,
                        backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                        fontWeight: tabsVal === 0 ? "bold" : "normal",
                      }}
                      className="AdminTab"
                    />
                  ) : null}
                  {cmpntGroup["audit"]?.Read ? (
                    <Tab
                      label="Audit"
                      value={3}
                      name="audit"
                      // style={tabStyle}
                      sx={{
                        ...tabStyle,
                        backgroundColor: tabsVal === 0 ? "#333" : "#1e1e1e",
                        fontWeight: tabsVal === 0 ? "bold" : "normal",
                      }}
                      className="AdminTab"
                    />
                  ) : null}
                  {/* {sessionStorage
                  .getItem("username")
                  ?.toLowerCase()
                  .match("admin") && cmpntGroup["user"] ? (
                  <Tab label="Show User" style={tabStyle} />
                ) : null} */}
                </Tabs>
              )}
            </AppBar>

            {!isUserValid ? (
              <>
                {tabsVal.name === "roles" && (
                  <>
                    <div
                      className={"d-flex col-md-12 AllRole"}
                      style={{ padding: "0px 0px" }}
                    >
                      <div
                        className={"col-md-6 col-sm-12"}
                        style={{ padding: "0px " }}
                      >
                        <AddRoles
                          setTabs={setTabs}
                          onPermission={(val, row) => {
                            setPermission(val);
                            // setRowData(row);
                          }}
                          pageIndexAddRole={pageIndexAddRole}
                          setPageIndexAddRole={setPageIndexAddRole}
                          pageSizeAddRole={pageSizeAddRole}
                          setPageSizeAddRole={setPageSizeAddRole}
                          onPermissionRole={(val, row) => {
                            setRowData(row);
                          }}
                        />
                      </div>
                      <div
                        className={"col-md-6 col-sm-12 VuserRole"}
                        style={{ paddingRight: "0px " }}
                      >
                        <VUserRole
                          setTabs={setTabs}
                          onPermission={permission}
                          pageIndexAddRole={pageIndexAddRole}
                          pageSizeAddRole={pageSizeAddRole}
                          setPermission={setPermission}
                          rowData={rowData.original}
                        />
                      </div>
                    </div>
                  </>
                )}
                {tabsVal.name === "user" && (
                  <Fragment>
                    <div className="d-flex">
                      <ShowAllUser
                        onClickEdting={onClickEdting}
                        onCancelEditing={onCancelEditing}
                        onUserPermission={handleSetUser}
                        setUserTablePagination={setUserTablePagination}
                        userTablePagination={userTablePagination}
                        pageIndexAddUser={pageIndexAddUser}
                        setPageIndexAddUser={setPageIndexAddUser}
                        pageSizeAddUser={pageSizeAddUser}
                        setPageSizeAddUser={setPageSizeAddUser}
                      />

                      <Modal
                        show={userPermission}
                        onHide={modalHideChange}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="modal-70w"
                        centered
                        // style={{margin:"10px"}}
                      >
                        <Modal.Header
                          // closeButton={userPermission}
                          style={{
                            backgroundColor: "#161616",
                            color: "#c7c7c7",
                          }}
                        >
                          <Modal.Title>
                            {!isEditing ? "Register User" : "Edit User"}
                          </Modal.Title>
                          <button
                            type="button"
                            className="close ml-auto"
                            style={{
                              color: "white",
                              height: "12px",
                              width: "12px",
                              marginRight: "2px",
                            }}
                            onClick={modalHideChange}
                          >
                            &times;
                          </button>
                        </Modal.Header>
                        <Modal.Body>
                          <div>
                            <Box
                              component="form"
                              className="addUserBox"
                              // onSubmit={(e) => handleSubmit(e)}
                              noValidate
                              autoComplete="off"
                              style={{ backgroundColor: "#333333" }}
                            >
                              <div className="col-sm-12">
                                <div className="d-flex">
                                  <div>
                                    <TextField
                                      name="username"
                                      label="User Name"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      className={textPlaceHolder.input}
                                      value={form.username}
                                      onFocus={handleChangesOnFocus}
                                      required
                                      onChange={handleChange}
                                      error={!!error.username}
                                      helperText={error.username}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  <div>
                                    <TextField
                                      inputMode="email"
                                      type="email"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      name="email"
                                      className={textPlaceHolder.input}
                                      label="Email"
                                      onFocus={handleChangesOnFocus}
                                      value={form.email}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.email}
                                      helperText={error.email}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="d-flex">
                                  <div>
                                    <TextField
                                      name="disp_name"
                                      label="Display Name"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      className={textPlaceHolder.input}
                                      value={form.disp_name}
                                      onFocus={handleChangesOnFocus}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.disp_name}
                                      helperText={error.disp_name}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <TextField
                                      name="company"
                                      label="Company"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      value={form.company}
                                      className={textPlaceHolder.input}
                                      onFocus={handleChangesOnFocus}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.company}
                                      helperText={error.company}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="d-flex">
                                  <div
                                    style={{
                                      paddingTop: "10px",
                                      marginRight: "12px",
                                      width: "207px",
                                    }}
                                  >
                                    <PhoneInput
                                      inputStyle={{
                                        width: "100%",
                                        height: "54px",
                                        backgroundColor: "#333333",
                                        color: "#c7c7c7",
                                        border: "1px solid #555", // optional: visible border
                                      }}
                                      buttonStyle={{
                                        backgroundColor: "#242424",
                                        border: "none",
                                      }}
                                      dropdownStyle={{
                                        backgroundColor: "#333333",
                                        color: "#c7c7c7",
                                      }}
                                      country={"us"}
                                      value={form.mobile}
                                      onChange={(value) => {
                                        setForm({ ...form, mobile: value });
                                        if (error.mobile) {
                                          setError({ ...error, mobile: "" });
                                        }
                                      }}
                                    />
                                  </div>
                                  <div>
                                    {!isEditing ? (
                                      <TextField
                                        type="password"
                                        InputLabelProps={{
                                          style: { color: "#000" }, // Set your desired color here
                                        }}
                                        defaultValue=""
                                        name="password"
                                        label="Password"
                                        className={textPlaceHolder.input}
                                        onFocus={handleChangesOnFocus}
                                        value={form.password}
                                        required
                                        onChange={handleChange}
                                        error={!!error.password}
                                        helperText={error.password}
                                        variant="outlined"
                                        style={{
                                          marginTop: "10px",
                                          marginRight: "10px",
                                        }}
                                        autoComplete="new-password"
                                      />
                                    ) : null}
                                  </div>
                                </div>
                                <div className="row">
                                  {/* <div className="col-sm-12"> */}
                                  <div className="d-flex col-sm-12">
                                    <TextField
                                      name="apikey"
                                      label="Api Key"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      required
                                      value={form.apikey}
                                      className={
                                        textPlaceHolder.input + "d-flex w-100"
                                      }
                                      disabled={true}
                                      error={!!error.apikey}
                                      helperText={error.apikey}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    {!isEditing ? (
                                      <Button
                                        className=""
                                        onClick={() => dispatch(getApiKey())}
                                        style={{
                                          display: "flex",
                                          width: "1px",
                                          color: "#c7c7c7",
                                        }}
                                      >
                                        <i className="fa-solid fa-rotate"></i>
                                      </Button>
                                    ) : null}
                                  </div>
                                </div>
                                <div
                                  className="row"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div className="col-sm-12">
                                    <FormControl
                                      sx={{ width: "100%" }}
                                      error={!!error.personName} // Make sure error is defined
                                      className="formControl-select"
                                    >
                                      <InputLabel
                                        id="demo-multiple-chip-label"
                                        className="mx-3"
                                        style={{ marginTop: "-17px" }}
                                      >
                                        Roles Assign
                                        <span
                                          style={{
                                            color: error.personName
                                              ? "red"
                                              : "",
                                          }}
                                        >
                                          {" "}
                                          *
                                        </span>
                                      </InputLabel>
                                      <Select
                                        labelId="demo-multiple-chip-label"
                                        id="demo-multiple-chip"
                                        multiple
                                        value={personName || []}
                                        onChange={handleChange}
                                        required={!isEditing}
                                        name="personName"
                                        input={
                                          <OutlinedInput
                                            id="select-multiple-chip"
                                            label="Roles Assign"
                                          />
                                        }
                                        renderValue={(selected) => (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: 1.5,
                                              minWidth: "200px",
                                            }}
                                          >
                                            {selected.length > 0
                                              ? selected.map((value) => (
                                                  <Chip
                                                    key={value}
                                                    label={value.toUpperCase()}
                                                  />
                                                ))
                                              : null}
                                          </Box>
                                        )}
                                      >
                                        {rolesData.length > 0
                                          ? rolesData.map((name) => (
                                              <MenuItem
                                                key={name.roleName}
                                                value={name.roleName}
                                                style={getStyles(
                                                  name,
                                                  personName
                                                )}
                                                className="dropdown_vertical"
                                              >
                                                {name.roleName}
                                              </MenuItem>
                                            ))
                                          : null}
                                      </Select>
                                      {error.personName && (
                                        <FormHelperText
                                          style={{ color: "red" }}
                                        >
                                          {error.personName}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                  </div>
                                  {/* </div> */}
                                </div>
                                <div
                                  className="row"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div className="col-sm-12">
                                    <InputLabel id="demo-multiple-name-label">
                                      Data Provider
                                      <span
                                        style={{
                                          color: error.dataProvider
                                            ? "red"
                                            : "",
                                        }}
                                      >
                                        {" "}
                                        *
                                      </span>
                                    </InputLabel>
                                    <Select
                                      labelId="demo-multiple-name-label"
                                      id="demo-multiple-name"
                                      // multiple
                                      name="dataProvider"
                                      label="Data Provider"
                                      value={dataProviderList || []}
                                      onChange={handleChange}
                                      input={
                                        <OutlinedInput label="Data Provider" />
                                      }
                                      // MenuProps={MenuProps}
                                      style={{
                                        width: "100%",
                                        border: error.dataProvider
                                          ? "1px solid red"
                                          : "",
                                      }}
                                    >
                                      {[
                                        { label: "ALL", value: "all" },
                                        ...dataProvider,
                                      ].map((name, index) => (
                                        <MenuItem
                                          key={index}
                                          value={name.value}
                                          className="dropdown_vertical"
                                          // style={getStyles(name, personName, theme)}
                                        >
                                          {name.label}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {error.dataProvider && (
                                      <FormHelperText style={{ color: "red" }}>
                                        {error.dataProvider}
                                      </FormHelperText>
                                    )}
                                    {/* </FormControl> */}
                                  </div>
                                </div>
                              </div>
                            </Box>
                          </div>
                        </Modal.Body>
                        <Modal.Footer
                          style={{
                            backgroundColor: "#161616",
                          }}
                        >
                          {JSON.parse(
                            sessionStorage.getItem("isAuthenticated")
                          ) ? (
                            cmpntGroup["user"]?.Add && (
                              <Button
                                type="button"
                                onClick={(e) => handleSubmit(e)}
                                startIcon={<SaveIcon />}
                                // style={{
                                //   backgroundColor: "#286685",
                                //   color: "#fff",
                                // }}
                                style={buttonStyle}
                                buttontype="info"
                              >
                                Save
                              </Button>
                            )
                          ) : (
                            <Button
                              type="button"
                              onClick={(e) => handleSubmit(e)}
                              startIcon={<SaveIcon />}
                              // style={{
                              //   backgroundColor: "#286685",
                              //   color: "#fff",
                              // }}
                              style={buttonStyle}
                              buttontype="info"
                            >
                              Save
                            </Button>
                          )}
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </Fragment>
                )}
                {/* {tabsVal === 3 && <ShowAllUser setTabs={setTabs} />} */}
              </>
            ) : (
              <>
                {tabsVal.name === "user" && (
                  <Fragment>
                    <div className="d-flex">
                      <ShowAllUser
                        onClickEdting={onClickEdting}
                        onCancelEditing={onCancelEditing}
                        onUserPermission={handleSetUser}
                        setUserTablePagination={setUserTablePagination}
                        userTablePagination={userTablePagination}
                        pageIndexAddUser={pageIndexAddUser}
                        setPageIndexAddUser={setPageIndexAddUser}
                        pageSizeAddUser={pageSizeAddUser}
                        setPageSizeAddUser={setPageSizeAddUser}
                      />

                      <Modal
                        show={userPermission}
                        onHide={modalHideChange}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="modal-70w"
                        centered
                        // style={{margin:"10px"}}
                      >
                        <Modal.Header
                          // closeButton={userPermission}
                          style={{
                            backgroundColor: "#161616",
                            color: "#c7c7c7",
                          }}
                        >
                          <Modal.Title>
                            {!isEditing ? "Register User" : "Edit User"}
                          </Modal.Title>
                          <button
                            type="button"
                            className="close ml-auto"
                            style={{
                              color: "white",
                              height: "12px",
                              width: "12px",
                              marginRight: "2px",
                            }}
                            onClick={modalHideChange}
                          >
                            &times;
                          </button>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: "#333333" }}>
                          <div>
                            <Box
                              component="form"
                              className="addUserBox"
                              // onSubmit={(e) => handleSubmit(e)}
                              noValidate
                              autoComplete="off"
                            >
                              <div className="col-sm-12">
                                <div className="d-flex">
                                  <div>
                                    <TextField
                                      name="username"
                                      label="User Name"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      className={textPlaceHolder.input}
                                      value={form.username}
                                      onFocus={handleChangesOnFocus}
                                      required
                                      onChange={handleChange}
                                      error={!!error.username}
                                      helperText={error.username}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  <div>
                                    <TextField
                                      inputMode="email"
                                      type="email"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      name="email"
                                      className={textPlaceHolder.input}
                                      label="Email"
                                      onFocus={handleChangesOnFocus}
                                      value={form.email}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.email}
                                      helperText={error.email}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="d-flex">
                                  <div>
                                    <TextField
                                      name="disp_name"
                                      label="Display Name"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      className={textPlaceHolder.input}
                                      value={form.disp_name}
                                      onFocus={handleChangesOnFocus}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.disp_name}
                                      helperText={error.disp_name}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <TextField
                                      name="company"
                                      label="Company"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      value={form.company}
                                      className={textPlaceHolder.input}
                                      onFocus={handleChangesOnFocus}
                                      // required
                                      onChange={handleChange}
                                      error={!!error.company}
                                      helperText={error.company}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </div>
                                </div>
                                {/* <div className="d-flex">
                              <div >
                                <TextField
                                  name="sname"
                                  label="Last Name"
                                  InputLabelProps={{
                                    style: { color: "#000" }, // Set your desired color here
                                  }}
                                  value={form.sname}
                                  className={textPlaceHolder.input}
                                  onFocus={handleChangesOnFocus}
                                  required
                                  onChange={handleChange}
                                  error={!!error.sname}
                                  helperText={error.sname}
                                  variant="outlined"
                                  style={{marginTop:"10px", marginRight:"10px"}}
                                />
                              </div>
                              <div >
                                
                              </div>
                            </div> */}
                                <div className="d-flex">
                                  <div
                                    style={{
                                      paddingTop: "10px",
                                      marginRight: "12px",
                                      width: "207px",
                                    }}
                                  >
                                    <PhoneInput
                                      inputStyle={{
                                        width: "100%",
                                        height: "54px",
                                        backgroundColor: "#333333",
                                        color: "#c7c7c7",
                                        border: "1px solid #555", // optional: visible border
                                      }}
                                      buttonStyle={{
                                        backgroundColor: "#242424",
                                        border: "none",
                                      }}
                                      dropdownStyle={{
                                        backgroundColor: "#333333",
                                        color: "#c7c7c7",
                                      }}
                                      country={"us"}
                                      value={form.mobile}
                                      onChange={(value) => {
                                        setForm({ ...form, mobile: value });
                                        if (error.mobile) {
                                          setError({ ...error, mobile: "" });
                                        }
                                      }}
                                    />
                                  </div>
                                  <div>
                                    {!isEditing ? (
                                      <TextField
                                        type="password"
                                        InputLabelProps={{
                                          style: { color: "#000" }, // Set your desired color here
                                        }}
                                        defaultValue=""
                                        name="password"
                                        label="Password"
                                        className={textPlaceHolder.input}
                                        onFocus={handleChangesOnFocus}
                                        value={form.password}
                                        required
                                        onChange={handleChange}
                                        error={!!error.password}
                                        helperText={error.password}
                                        variant="outlined"
                                        style={{
                                          marginTop: "10px",
                                          marginRight: "10px",
                                        }}
                                        autoComplete="new-password"
                                      />
                                    ) : null}
                                  </div>
                                </div>
                                <div className="row">
                                  {/* <div className="col-sm-12"> */}
                                  <div className="d-flex col-sm-12">
                                    <TextField
                                      name="apikey"
                                      label="Api Key"
                                      InputLabelProps={{
                                        style: { color: "#000" }, // Set your desired color here
                                      }}
                                      required
                                      value={form.apikey}
                                      className={
                                        textPlaceHolder.input + "d-flex w-100"
                                      }
                                      disabled={true}
                                      error={!!error.apikey}
                                      helperText={error.apikey}
                                      variant="outlined"
                                      style={{
                                        marginTop: "10px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    {!isEditing ? (
                                      <Button
                                        className=""
                                        onClick={() => dispatch(getApiKey())}
                                        style={{
                                          display: "flex",
                                          width: "1px",
                                          color: "#c7c7c7",
                                        }}
                                      >
                                        <i className="fa-solid fa-rotate"></i>
                                      </Button>
                                    ) : null}
                                  </div>
                                </div>
                                <div
                                  className="row"
                                  style={{ marginTop: "25px" }}
                                >
                                  <div className="col-sm-12">
                                    <FormControl
                                      sx={{ width: "100%" }}
                                      error={!!error.personName} // Make sure error is defined
                                      className="formControl-select"
                                    >
                                      <InputLabel
                                        id="roles-assign-label"
                                        htmlFor="select-multiple-chip"
                                        className="mx-3"
                                        shrink
                                        style={{ marginTop: "-17px" }}
                                      >
                                        Roles Assign
                                        <span
                                          style={{
                                            color: error.personName
                                              ? "red"
                                              : "",
                                          }}
                                        >
                                          {" "}
                                          *
                                        </span>
                                      </InputLabel>

                                      <Select
                                        labelId="demo-multiple-chip-label"
                                        id="demo-multiple-chip"
                                        multiple
                                        value={personName || []}
                                        onChange={handleChange}
                                        required={!isEditing}
                                        name="personName"
                                        input={
                                          <OutlinedInput
                                            id="select-multiple-chip"
                                            label="Roles Assign"
                                            style={{
                                              color: "#c7c7c7", // ✅ Text color inside input
                                              backgroundColor: "#333333", // Optional: dark background
                                            }}
                                          />
                                        }
                                        renderValue={(selected) => (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: 1.5,
                                              minWidth: "200px",
                                            }}
                                          >
                                            {selected.length > 0
                                              ? selected.map((value) => (
                                                  <Chip
                                                    key={value}
                                                    label={value.toUpperCase()}
                                                  />
                                                ))
                                              : null}
                                          </Box>
                                        )}
                                      >
                                        {rolesData.length > 0
                                          ? rolesData.map((name) => (
                                              <MenuItem
                                                key={name.roleName}
                                                value={name.roleName}
                                                style={getStyles(
                                                  name,
                                                  personName
                                                )}
                                                className="dropdown_vertical"
                                              >
                                                {name.roleName}
                                              </MenuItem>
                                            ))
                                          : null}
                                      </Select>
                                      {error.personName && (
                                        <FormHelperText
                                          style={{ color: "red" }}
                                        >
                                          {error.personName}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                  </div>
                                  {/* </div> */}
                                </div>
                                <div
                                  className="row"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div className="col-sm-12">
                                    {/* <Autocomplete
                                        disablePortal
                                        // id="combo-box-demo"
                                        options={dataProvider}
                                        sx={{ width: 400 }}
                                        freeSolo
                                        id="free-solo-with-text-demo"
                                        renderInput={(params) => <TextField {...params} label="Data provider" />}
                                      /> */}
                                    {/* <FormControl
                                    sx={{ width: "100%" }}
                                    error={!!error.dataProvider} // Make sure error is defined
                                    className="formControl-select"
                                  > */}
                                    <InputLabel id="demo-multiple-name-label">
                                      Data Provider
                                      <span
                                        style={{
                                          color: error.dataProvider
                                            ? "red"
                                            : "",
                                        }}
                                      >
                                        {" "}
                                        *
                                      </span>
                                    </InputLabel>
                                    <Select
                                      labelId="demo-multiple-name-label"
                                      id="demo-multiple-name"
                                      // multiple
                                      name="dataProvider"
                                      label="Data Provider"
                                      value={dataProviderList || []}
                                      onChange={handleChange}
                                      input={
                                        <OutlinedInput label="Data Provider" />
                                      }
                                      // MenuProps={MenuProps}
                                      style={{
                                        width: "100%",
                                        border: error.dataProvider
                                          ? "1px solid red"
                                          : "",
                                      }}
                                    >
                                      {[
                                        { label: "ALL", value: "all" },
                                        ...dataProvider,
                                      ].map((name, index) => (
                                        <MenuItem
                                          key={index}
                                          value={name.value}
                                          className="dropdown_vertical"
                                          // style={getStyles(name, personName, theme)}
                                        >
                                          {name.label}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {error.dataProvider && (
                                      <FormHelperText style={{ color: "red" }}>
                                        {error.dataProvider}
                                      </FormHelperText>
                                    )}
                                    {/* </FormControl> */}
                                  </div>
                                </div>
                              </div>
                            </Box>
                          </div>
                        </Modal.Body>
                        <Modal.Footer
                          style={{
                            backgroundColor: "#161616",
                          }}
                        >
                          {JSON.parse(
                            sessionStorage.getItem("isAuthenticated")
                          ) ? (
                            cmpntGroup["user"]?.Add && (
                              <Button
                                type="button"
                                onClick={(e) => handleSubmit(e)}
                                startIcon={<SaveIcon />}
                                // style={{
                                //   backgroundColor: "#286685",
                                //   color: "#fff",
                                // }}
                                style={buttonStyle}
                                buttontype="info"
                              >
                                Save
                              </Button>
                            )
                          ) : (
                            <Button
                              type="button"
                              onClick={(e) => handleSubmit(e)}
                              startIcon={<SaveIcon />}
                              style={buttonStyle}
                              // style={{
                              //   backgroundColor: "#286685",
                              //   color: "#fff",
                              // }}
                              buttontype="info"
                            >
                              Save
                            </Button>
                          )}
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </Fragment>
                )}

                {tabsVal.name === "userRoles" && (
                  <>
                    <div
                      className={"d-flex col-md-12 AllRole"}
                      style={{ padding: "0px 00px" }}
                    >
                      <div
                        className={"col-md-6 col-sm-12"}
                        style={{ padding: "0px " }}
                      >
                        <AddRoles
                          setTabs={setTabs}
                          onPermission={(val, row) => {
                            setPermission(val);
                            // setRowData(row);
                          }}
                          pageIndexAddRole={pageIndexAddRole}
                          setPageIndexAddRole={setPageIndexAddRole}
                          pageSizeAddRole={pageSizeAddRole}
                          setPageSizeAddRole={setPageSizeAddRole}
                          onPermissionRole={(val, row) => {
                            setRowData(row);
                          }}
                        />
                      </div>
                      <div
                        className={"col-md-6 col-sm-12 VuserRole"}
                        style={{ paddingRight: "0px " }}
                      >
                        <VUserRole
                          setTabs={setTabs}
                          onPermission={permission}
                          pageIndexAddRole={pageIndexAddRole}
                          pageSizeAddRole={pageSizeAddRole}
                          setPermission={setPermission}
                          rowData={rowData.original}
                        />
                      </div>
                    </div>
                  </>
                )}

                {tabsVal.name === "appProperties" && (
                  <AppConfigPage
                    setPageSizeAppProp={setPageSizeAppProp}
                    pageSizeAppProp={pageSizeAppProp}
                    pageIndexAppProp={pageIndexAppProp}
                    setPageIndexAppProp={setPageIndexAppProp}
                  />
                )}
                {tabsVal.name === "audit" && (
                  <>
                    <Audit />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default VUser;
